export const GET_TASKS = 'app/tasks/GET_TASKS';
export const GET_STATUS = 'app/tasks/GET_STATUS';
export const GET_ORDERS_TASK = 'app/tasks/GET_ORDERS_TASK';
export const GET_MAP_MARKERS = 'app/tasks/GET_MAP_MARKERS';
export const POST_ASSIGN_ME_TASK = 'app/tasks/POST_ASSIGN_ME_TASK';
export const GET_ASSETS_TASKS = 'app/tasks/GET_ASSETS_TASKS';
export const POST_ASSETS_TASK = 'app/tasks/POST_ASSETS_TASK';
